import { useState, useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { BrainMockup } from './platform/BrainMockup'
import { BuildMockup } from './platform/BuildMockup'
import { GovernMockup } from './platform/GovernMockup'

const mockups = [
  { key: 'brain', component: BrainMockup },
  { key: 'build', component: BuildMockup },
  { key: 'govern', component: GovernMockup },
]

export function HeroMockupCarousel() {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % mockups.length)
    }, 6000)
    return () => clearInterval(interval)
  }, [])

  const CurrentMockup = mockups[index].component

  return (
    <div className="relative h-full w-full">
      <AnimatePresence mode="wait">
        <motion.div
          key={mockups[index].key}
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.98 }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
          className="h-full w-full"
        >
          <CurrentMockup />
        </motion.div>
      </AnimatePresence>

      <div className="absolute bottom-3 left-1/2 z-20 flex -translate-x-1/2 gap-2">
        {mockups.map((m, i) => (
          <button
            key={m.key}
            type="button"
            onClick={() => setIndex(i)}
            className={`h-1.5 rounded-full transition-all ${
              i === index ? 'w-6 bg-accent-light' : 'w-1.5 bg-text-muted/50 hover:bg-text-muted'
            }`}
            aria-label={`Mostrar ${m.key}`}
          />
        ))}
      </div>
    </div>
  )
}
